__turbopack_context__.v({
  "card": "index-module-scss-module__mZ41VW__card",
  "cardDescription": "index-module-scss-module__mZ41VW__cardDescription",
  "cardEyebrow": "index-module-scss-module__mZ41VW__cardEyebrow",
  "cardTitle": "index-module-scss-module__mZ41VW__cardTitle",
  "container": "index-module-scss-module__mZ41VW__container",
  "eyebrow": "index-module-scss-module__mZ41VW__eyebrow",
  "gridWrap": "index-module-scss-module__mZ41VW__gridWrap",
  "section": "index-module-scss-module__mZ41VW__section",
  "supportingText": "index-module-scss-module__mZ41VW__supportingText",
  "title": "index-module-scss-module__mZ41VW__title",
});
